import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { LoadingController, NavController, NavParams } from "ionic-angular";
import { RestProvider } from "../../providers/rest/rest";
declare var google
@Component({
  selector: "app-cow_graphic",
  templateUrl: "cow_graphic.html"
})
export class GraphicPage {

  public cow_code: string;
  public CowWeightArray = [];
  public CowWeightArray1 = [];
  public loader;
  public id;
  public cows = [];

  public host: string = '';
  constructor(
    public navCtrl: NavController,
    navParams: NavParams,
    private rest: RestProvider,
    public loadingCtrl: LoadingController,
    protected datepipe: DatePipe,
  ) {

    this.id = navParams.get('id');
    this.cow_code = navParams.get('cow_code');
  }
  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(() => {
      this.loader = null;
    })
  }
  hideLoader() {
    if (this.loader)
      this.loader.dismiss();
  }
  ionViewDidLoad() {
    this.showLoader();
    console.log(this.cow_code);
    this.host = RestProvider.HOST;
    this.drawVisualization();
    this.drawChart();
    this.rest.UpdateCowsGet(this.id).subscribe(
      (res) => {
        this.cows = res;
        console.log(res);
      }
    );
    this.hideLoader();
  }
  drawVisualization() {
    // this.showLoader();
    this.rest.CowCode(this.cow_code).subscribe(
      (res) => {
        console.log(res)
        this.CowWeightArray = res;
        var array = [];
        if (res) {
          for (let i = 0; i < this.CowWeightArray.length; i++) {
            let innerArray = [];
            // innerArray.push(this.CowWeightArray[i].recieve_date.split(' ')[0]);
            innerArray.push(this.datepipe.transform(this.CowWeightArray[i].recieve_date, 'MM-dd'));
            innerArray.push(Number(this.CowWeightArray[i].cow_weight));
            innerArray.push(Number(this.CowWeightArray[i].cow_temperature));
            innerArray.push(Number(this.CowWeightArray[i].cow_height));
            console.log(innerArray);
            array.push(innerArray);
          }
          var data = new google.visualization.arrayToDataTable(array, true);
          console.log(array)
          var options = {
            title: 'Үхрийн график',
            vAxis: { title: 'Нэгж' },
            hAxis: { title: 'Цаг хугацаа' },
            seriesType: 'bars',
            series: { 5: { type: 'line' } }
          };
          var chart = new google.visualization.ComboChart(document.getElementById('graphic'));
          console.log(chart)
          chart.draw(data, options);
          // this.hideLoader();
        } else {
          // this.hideLoader();
        }
      }
    );
  }
  drawChart() {
    this.showLoader();
    this.rest.CowCode(this.cow_code).subscribe(
      (res) => {
        console.log(res)
        this.CowWeightArray1 = res;
        var array = [];
        if (res) {
          for (let i = 0; i < this.CowWeightArray1.length; i++) {
            let innerArray = [];
            innerArray.push(this.datepipe.transform(this.CowWeightArray1[i].recieve_date, 'MM-dd'));
            // innerArray.push(this.CowWeightArray1[i].recieve_date.split(' ')[0]);
            innerArray.push(Number(this.CowWeightArray1[i].cow_weight));
            array.push(innerArray);
          }
          var data = google.visualization.arrayToDataTable(array, true);
          var options = {
            title: 'Жингийн график',
            vAxis: { title: 'Жин кг' },
            isStacked: true
          };
          var chart = new google.visualization.SteppedAreaChart(document.getElementById('graphic1'));
          chart.draw(data, options);
        }
        this.hideLoader();
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/cow_graphic/cow_graphic.ts